import { AssessmentDefinition, CalculationType, InputType, SideType } from '../models/assessment-definition.model';

export const NHPTDefinition: AssessmentDefinition = {
  id: 'nhpt',
  version: '1.0',
  name: 'Nine Hole Peg Test',
  shortName: 'NHPT',
  description:
    'Der Nine Hole Peg Test ist ein Test zur Bewertung der Feinmotorik und Geschicklichkeit der oberen Extremitäten.',
  guide: `
      <h4>Durchführung</h4>
      <p>Der Patient sitzt an einem Tisch mit dem Testbrett vor sich. Das Testbrett besteht aus einer quadratischen Platte mit 9 Löchern und einem Behälter mit 9 Stiften.</p>
      <p>Der Patient soll die Stifte einzeln so schnell wie möglich in die Löcher stecken und anschließend wieder herausnehmen und in den Behälter zurücklegen. Die Zeit wird gestoppt, sobald der letzte Stift wieder im Behälter liegt.</p>
      <p>Der Test wird für jede Hand durchgeführt, wobei mit der weniger betroffenen Hand begonnen wird.</p>
      <p>Falls der Patient nicht in der Lage ist, alle Stifte innerhalb von 60 Sekunden einzustecken und herauszunehmen, wird der Test abgebrochen und die Anzahl der bis dahin eingesteckten bzw. herausgenommenen Stifte notiert.</p>
      <h4>Auswertung</h4>
      <p>Die Zeit in Sekunden wird als Ergebnis festgehalten. Bei Nichtvollständigkeit innerhalb von 60 Sekunden wird die Anzahl der eingesteckten bzw. herausgenommenen Stifte dokumentiert.</p>
      <p>Die Ergebnisse werden mit altersspezifischen Normwerten verglichen.</p>
    `,
  groups: [
    {
      id: 'main',
      title: 'Haupttest',
      description: 'Durchführung des NHPT für beide Hände',
      tasks: [
        {
          id: 'time',
          title: 'Zeiterfassung',
          description: 'Benötigte Zeit in Sekunden',
          guide: `
              <p>Messen Sie die Zeit in Sekunden, die der Patient benötigt, um alle 9 Stifte einzustecken und wieder zu entfernen.</p>
              <p>Starten Sie die Stoppuhr, sobald der Patient den ersten Stift berührt, und stoppen Sie sie, sobald der letzte Stift wieder im Behälter liegt.</p>
              <p>Wenn der Patient nicht alle Stifte innerhalb von 60 Sekunden einsetzen und herausnehmen kann, tragen Sie 60 Sekunden ein und geben Sie die Anzahl der Stifte im Abschnitt unten an.</p>
            `,
          inputType: InputType.Number,
          minValue: 0,
          maxValue: 300, // Maximum 5 Minuten für Patienten mit starken Einschränkungen
          specialConfig: {
            completionStatus: {
              label: 'Test-Status',
              inputType: InputType.RadioGroup,
              options: [
                { value: 'complete', label: 'Test vollständig abgeschlossen' },
                { value: 'incomplete', label: 'Test nicht innerhalb von 60 Sekunden abgeschlossen' },
              ],
              isRequired: true,
              defaultValue: 'complete',
            },
            pegsInserted: {
              label: 'Eingesteckte Stifte (bei Nichtvollständigkeit)',
              inputType: InputType.Number,
              minValue: 0,
              maxValue: 9,
              defaultValue: 0,
            },
            pegsRemoved: {
              label: 'Herausgenommene Stifte (bei Nichtvollständigkeit)',
              inputType: InputType.Number,
              minValue: 0,
              maxValue: 9,
              defaultValue: 0,
            },
          },
          sideType: SideType.Both,
          icfCategories: [
            { code: 'b760', description: 'Funktionen der Kontrolle von Willkürbewegungen' },
            { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
          ],
        },
      ],
    },
  ],
  icfCategories: [
    { code: 'b760', description: 'Funktionen der Kontrolle von Willkürbewegungen' },
    { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
  ],
  calculationType: CalculationType.NormValueComparison,
  normValues: [
    {
      gender: 'male',
      minAge: 20,
      maxAge: 29,
      avgValue: 16.9,
      stdDeviation: 1.4,
      calculationMethod: 'nhptCalculation',
    },
    {
      gender: 'female',
      minAge: 20,
      maxAge: 29,
      avgValue: 15.4,
      stdDeviation: 1.5,
      calculationMethod: 'nhptCalculation',
    },
    // Fallback-Normwert für alle anderen Fälle
    {
      gender: 'diverse',
      minAge: 0,
      maxAge: 150,
      avgValue: 18.0,
      stdDeviation: 3.0,
      calculationMethod: 'nhptCalculation',
    },
  ],
  showPercentFulfillment: true,
  showICFScore: true,
  requiresPatientData: true,
  sideType: SideType.Both,
};
